import SpinModel from "../../model/SpinModel";
import { ICondition } from "../State";
import { OverlayType } from "../../server/data/ISpinData";

export default class HasRandomSymbolsCondition  implements ICondition {
    public check(): boolean {
        return SpinModel.hasOverlay(OverlayType.Random);
    }
}
